// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tYZonBvDxggpt0q7 {
  margin-top: 10px;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
}
.tYZonBvDxggpt0q7 .gNyNVaVlBuUDeBiN {
  font-size: 12px;
  color: #5a687c;
  cursor: pointer;
}
.tYZonBvDxggpt0q7 .YNZFvyp6QUQYLhkr {
  margin-left: 5px;
}
.tYZonBvDxggpt0q7 .el9HIrE39uU4W03O {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.tYZonBvDxggpt0q7 .SBIdTRA9ZlAwmPLw {
  margin-left: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  color: #1677ff;
  border: 1px solid #e0edfe;
  background: #eff6ff;
  font-size: 12px;
  font-weight: bold;
  box-sizing: border-box;
}
.qyh6gsyMGd4AGh2u {
  border: 1px solid #ebebeb;
}
.aH6qrGlX95kR_LV4 {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.aH6qrGlX95kR_LV4 .zbEW6STCUgC3V8rX {
  font-size: 14px;
  color: #5a687c;
  margin-bottom: 5px;
}
.aH6qrGlX95kR_LV4 .Gpb7vSKnN00OqxKq {
  width: 30%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.aH6qrGlX95kR_LV4 .Gpb7vSKnN00OqxKq .xAzXw1zHyvoXXB_L {
  margin-left: 10px;
}
.aH6qrGlX95kR_LV4 .Iy7SLiPjj4fpvn51 {
  color: #1677ff;
}
.aH6qrGlX95kR_LV4 .VruUblXBJxs5Z1ty {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tuXJhtor91g2gwW0 {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.jAsjt6yyc7UPyk2q {
  margin: 20px auto;
  width: calc(100vw - 60px);
}
.jAsjt6yyc7UPyk2q .Ww8sIQZTnf88MMzr {
  background: #fff;
  border: none;
  margin-top: 20px;
}
.jAsjt6yyc7UPyk2q .bvPkOQrBq8o7OopG {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .TIPXF_ajr7YxRFdq {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e8e8e8;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .oWlK16b7sKMUBXqX {
  margin-right: 20px;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .wofRwBdgnl43v2UB {
  width: 100%;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .wofRwBdgnl43v2UB .TxH68m3wSck4uCZQ {
  width: 80%;
  height: auto;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 0 10px 10px 10px;
  background: #fff;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .wofRwBdgnl43v2UB .TnYe_am82AnjP4HI {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .wofRwBdgnl43v2UB .RpRno8rKMOMQSK3a {
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .wofRwBdgnl43v2UB .I1ciqLGRHQkwruLv {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .OLvn0C2mn9sEDWYq {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .OLvn0C2mn9sEDWYq .tG5R9ZmShko22kYl {
  box-sizing: border-box;
  background-color: #eff6ff;
  border: 1px solid #e4f0ff;
  border-radius: 25px;
  padding: 12px 16px;
  margin: 20px;
  display: flex;
  align-items: center;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .OLvn0C2mn9sEDWYq .tG5R9ZmShko22kYl .R8f9LAmikIAEGq7x {
  width: 18px;
  height: 18px;
  color: #1677ff;
  font-size: 20px;
  margin-right: 5px;
}
.jAsjt6yyc7UPyk2q .bamuHvFCCwSB3boP .OLvn0C2mn9sEDWYq .tG5R9ZmShko22kYl .NEB9t0_YYr0DBCH0 {
  color: #1677ff;
  font-size: 14px;
  font-weight: bold;
}
.jAsjt6yyc7UPyk2q .uNFvOf41iAP4P4ZB {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
}
.jAsjt6yyc7UPyk2q .uNFvOf41iAP4P4ZB .VBy4TE1PiR0iXoZb {
  width: 94%;
}
.jAsjt6yyc7UPyk2q .uNFvOf41iAP4P4ZB .xijpiwVWzpoAgzVj {
  width: 100%;
  background: rgba(248, 250, 252);
}
.Sx1xkdNmHBAsLRBM .tYZonBvDxggpt0q7 {
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
}
.Sx1xkdNmHBAsLRBM .tuXJhtor91g2gwW0 {
  min-height: 36px;
  padding-right: 4px;
}
.Sx1xkdNmHBAsLRBM .el9HIrE39uU4W03O {
  font-size: 15px;
}
.Sx1xkdNmHBAsLRBM .aH6qrGlX95kR_LV4 {
  padding: 12px;
}
.Sx1xkdNmHBAsLRBM .VruUblXBJxs5Z1ty,
.Sx1xkdNmHBAsLRBM .h0u5lee73IRCk6EE {
  white-space: normal;
  word-break: break-all;
}
.Sx1xkdNmHBAsLRBM .Gpb7vSKnN00OqxKq {
  width: 100%;
  margin-top: 4px;
  justify-content: stretch;
  gap: 8px;
}
.Sx1xkdNmHBAsLRBM .Gpb7vSKnN00OqxKq .xAzXw1zHyvoXXB_L {
  margin-left: 0;
}
.Sx1xkdNmHBAsLRBM .Gpb7vSKnN00OqxKq button {
  flex: 1;
}
.Sx1xkdNmHBAsLRBM .jAsjt6yyc7UPyk2q {
  width: 100%;
  margin: 12px 0 24px;
  padding: 0 12px;
  box-sizing: border-box;
}
.Sx1xkdNmHBAsLRBM .bamuHvFCCwSB3boP {
  padding: 12px;
}
.Sx1xkdNmHBAsLRBM .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .TIPXF_ajr7YxRFdq {
  flex-shrink: 0;
}
.Sx1xkdNmHBAsLRBM .bamuHvFCCwSB3boP .LSITa7zJCo0Adlim .wofRwBdgnl43v2UB .TxH68m3wSck4uCZQ {
  width: 100%;
  word-break: break-all;
}
.Sx1xkdNmHBAsLRBM .bamuHvFCCwSB3boP .OLvn0C2mn9sEDWYq .tG5R9ZmShko22kYl {
  margin: 8px 0;
  border-radius: 12px;
  align-items: flex-start;
}
.Sx1xkdNmHBAsLRBM .bvPkOQrBq8o7OopG,
.Sx1xkdNmHBAsLRBM .uNFvOf41iAP4P4ZB {
  padding: 12px;
}
.Sx1xkdNmHBAsLRBM .uNFvOf41iAP4P4ZB {
  flex-direction: column;
  align-items: stretch;
}
.Sx1xkdNmHBAsLRBM .uNFvOf41iAP4P4ZB .VBy4TE1PiR0iXoZb {
  width: 100%;
}
.Sx1xkdNmHBAsLRBM .uNFvOf41iAP4P4ZB button {
  width: 100%;
}
.Sx1xkdNmHBAsLRBM .VQbGz2XIPIT4N_Bc {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 12px 12px;
}
.Sx1xkdNmHBAsLRBM .jrOWTQyF7eAHyxOY {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}
.Sx1xkdNmHBAsLRBM .dPQWBBrrl_43nCFB {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.Sx1xkdNmHBAsLRBM .EYAIuhlOL446AToH {
  font-weight: 600;
  word-break: break-all;
}
.Sx1xkdNmHBAsLRBM .Q04aJVgODcE6zZy5 {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  line-height: 1.6;
}
.Sx1xkdNmHBAsLRBM .Q04aJVgODcE6zZy5 span:first-child {
  flex-shrink: 0;
  color: #8c8c8c;
}
.Sx1xkdNmHBAsLRBM .Q04aJVgODcE6zZy5 span:last-child {
  text-align: right;
  word-break: break-all;
}
.Sx1xkdNmHBAsLRBM .jrOWTQyF7eAHyxOY button {
  margin-top: 12px;
}
.Sx1xkdNmHBAsLRBM .ant-input,
.Sx1xkdNmHBAsLRBM .ant-input-textarea textarea {
  font-size: 16px;
}
.Sx1xkdNmHBAsLRBM .ant-steps-item-title {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/newComplaintDetail/index.modules.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AACF;AATA;EAWI,eAAA;EACA,cAAA;EACA,eAAA;AACJ;AAdA;EAgBI,gBAAA;AACJ;AAjBA;EAoBI,eAAA;EACA,iBAAA;EACA,cAAA;AAAJ;AAtBA;EA0BI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AADJ;AAMA;EACE,yBAAA;AAJF;AAQA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AANF;AAEA;EAOI,eAAA;EACA,cAAA;EACA,kBAAA;AANJ;AAHA;EAaI,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAPJ;AATA;EAmBM,iBAAA;AAPN;AAZA;EAwBI,cAAA;AATJ;AAfA;EA4BI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAVJ;AAcA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAZF;AAeA;EACE,iBAAA;EACA,yBAAA;AAbF;AAWA;EAKI,gBAAA;EACA,YAAA;EACA,gBAAA;AAbJ;AAMA;EAWI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AAdJ;AAFA;EAoBI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;AAfJ;AAVA;EA4BM,aAAA;EACA,2BAAA;EACA,uBAAA;AAfN;AAfA;EAiCQ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAfR;AA1BA;EA6CQ,kBAAA;AAhBR;AA7BA;EAiDQ,WAAA;AAjBR;AAhCA;EAoDU,UAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;AAjBV;AAzCA;EA8DU,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAlBV;AA/CA;EAqEU,iBAAA;EACA,kBAAA;EACA,yBAAA;AAnBV;AApDA;EA2EU,eAAA;EACA,cAAA;EACA,eAAA;AApBV;AAzDA;EAqFM,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAzBN;AAhEA;EA+FQ,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA5BR;AA1EA;EAyGU,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA5BV;AAjFA;EAiHU,cAAA;EACA,eAAA;EACA,iBAAA;AA7BV;AAtFA;EA2HI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;AAlCJ;AA/FA;EAmIM,UAAA;AAjCN;AAlGA;EAsIM,WAAA;EACA,+BAAA;AAjCN;AAsCA;EAEI,eAAA;EACA,QAAA;EACA,aAAA;AArCJ;AAiCA;EAQI,gBAAA;EACA,kBAAA;AAtCJ;AA6BA;EAaI,eAAA;AAvCJ;AA0BA;EAiBI,aAAA;AAxCJ;AAuBA;;EAsBI,mBAAA;EACA,qBAAA;AAzCJ;AAkBA;EA2BI,WAAA;EACA,eAAA;EACA,wBAAA;EACA,QAAA;AA1CJ;AAYA;EAiCM,cAAA;AA1CN;AASA;EAqCM,OAAA;AA3CN;AAMA;EA0CI,WAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AA7CJ;AAAA;EAiDI,aAAA;AA9CJ;AAHA;EAqDQ,cAAA;AA/CR;AANA;EAyDQ,WAAA;EACA,qBAAA;AAhDR;AAVA;EA+DM,aAAA;EACA,mBAAA;EACA,uBAAA;AAlDN;AAfA;;EAuEI,aAAA;AApDJ;AAnBA;EA2EI,sBAAA;EACA,oBAAA;AArDJ;AAvBA;EA+EM,WAAA;AArDN;AA1BA;EAmFM,WAAA;AAtDN;AA7BA;EAwFI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAxDJ;AAnCA;EA+FI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAzDJ;AAzCA;EAsGI,aAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AA1DJ;AA/CA;EA6GI,gBAAA;EACA,qBAAA;AA3DJ;AAnDA;EAkHI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AA5DJ;AA1DA;EAyHM,cAAA;EACA,cAAA;AA5DN;AA9DA;EA8HM,iBAAA;EACA,qBAAA;AA7DN;AAlEA;EAoII,gBAAA;AA/DJ;AArEA;;EA0IM,eAAA;AAjEN;AAzEA;EA8IM,eAAA;AAlEN","sourcesContent":[".complaintTitle {\n  margin-top: 10px;\n  width: 100%;\n  background: #fff;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 20px;\n\n  .goBackText {\n    font-size: 12px;\n    color: #5a687c;\n    cursor: pointer;\n  }\n  .goBackTextMargin{\n    margin-left: 5px;\n  }\n\n  .complaintMainTitle {\n    font-size: 16px;\n    font-weight: bold;\n    color: #333333;\n  }\n\n  .complaintTitleTags {\n    margin-left: 10px;\n    padding: 2px 8px;\n    border-radius: 4px;\n    color: #1677ff;\n    border: 1px solid rgb(224, 237, 254);\n    background: rgb(239, 246, 255);\n    font-size: 12px;\n    font-weight: bold;\n    box-sizing: border-box;\n  }\n\n}\n\n.borderTopLine {\n  border: 1px solid #ebebeb;\n\n}\n\n.compaintInfo {\n  width: 100%;\n  background: #fff;\n  padding: 20px;\n  box-sizing: border-box;\n\n  .compaintInfoTitle {\n    font-size: 14px;\n    color: #5a687c;\n    margin-bottom: 5px;\n  }\n\n  .complainBtnGroup {\n    width: 30%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    .btnFinsh {\n      margin-left: 10px;\n    }\n  }\n\n  .compaintInfoMoney {\n    color: #1677ff;\n  }\n\n  .productName {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.goBack {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.complaintDetailWidthWrapper {\n  margin: 20px auto;\n  width: calc(100vw - 60px);\n\n  .complaintDetailListStyle {\n    background: #fff;\n    border: none;\n    margin-top: 20px;\n  }\n\n  .ComplaintCardTitle {\n    width: 100%;\n    padding: 20px;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .ComplaintCardContent {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 20px;\n    border-top: 1px solid #e8e8e8;\n    border-bottom: 1px solid #e8e8e8;\n    background: #fafafa;\n\n    .ComplaintResponse {\n      display: flex;\n      justify-content: flex-start;\n      align-items: flex-start;\n\n      .ComplaintResponseUser {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        border: 1px solid #e8e8e8;\n        font-size: 12px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #fff;\n      }\n\n      .ComplaintUserMarginRight {\n        margin-right: 20px;\n      }\n\n      .ComplaintResponseSessionWapper {\n        width: 100%;\n\n        .ComplaintResponseSession {\n          width: 80%;\n          height: auto;\n          box-sizing: border-box;\n          padding: 10px;\n          border: 1px solid #e8e8e8;\n          border-radius: 0 10px 10px 10px;\n          background: #fff;\n        }\n\n        .replyImages {\n          display: flex;\n          flex-wrap: wrap;\n          gap: 8px;\n          margin-top: 10px;\n        }\n\n        .replyImage {\n          object-fit: cover;\n          border-radius: 4px;\n          border: 1px solid #e8e8e8;\n        }\n\n        .ComplaintResponseSessionDate {\n          font-size: 12px;\n          color: #999999;\n          margin-top: 5px;\n        }\n      }\n\n\n    }\n\n    .alipayTip {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-top: 10px;\n\n      .alipaywrap {\n\n\n\n        box-sizing: border-box;\n        background-color: rgb(239,246,255);\n        border: 1px solid rgb(228,240,255);\n        border-radius: 25px;\n        padding: 12px 16px;\n        margin: 20px;\n        display: flex;\n        align-items: center;\n\n        .alipayTipIcon {\n          width: 18px;\n          height: 18px;\n          color: #1677ff;\n          font-size: 20px;\n          margin-right: 5px;\n        }\n\n        .alipayTipText {\n          color: #1677ff;\n          font-size: 14px;\n          font-weight: bold;\n\n        }\n      }\n    }\n  }\n\n  .ComplaintCardFooter {\n    width: 100%;\n    padding: 20px;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 16px;\n    .replyInputWrapper {\n      width: 94%;\n    }\n    .textAreaStyle{\n      width: 100%;\n      background: rgba(248, 250, 252);\n    }\n  }\n}\n\n.isMobile {\n  .complaintTitle {\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 12px;\n  }\n\n  .goBack {\n    min-height: 36px;\n    padding-right: 4px;\n  }\n\n  .complaintMainTitle {\n    font-size: 15px;\n  }\n\n  .compaintInfo {\n    padding: 12px;\n  }\n\n  .productName,\n  .infoValue {\n    white-space: normal;\n    word-break: break-all;\n  }\n\n  .complainBtnGroup {\n    width: 100%;\n    margin-top: 4px;\n    justify-content: stretch;\n    gap: 8px;\n\n    .btnFinsh {\n      margin-left: 0;\n    }\n\n    button {\n      flex: 1;\n    }\n  }\n\n  .complaintDetailWidthWrapper {\n    width: 100%;\n    margin: 12px 0 24px;\n    padding: 0 12px;\n    box-sizing: border-box;\n  }\n\n  .ComplaintCardContent {\n    padding: 12px;\n\n    .ComplaintResponse {\n      .ComplaintResponseUser {\n        flex-shrink: 0;\n      }\n\n      .ComplaintResponseSessionWapper .ComplaintResponseSession {\n        width: 100%;\n        word-break: break-all;\n      }\n    }\n\n    .alipayTip .alipaywrap {\n      margin: 8px 0;\n      border-radius: 12px;\n      align-items: flex-start;\n    }\n  }\n\n  .ComplaintCardTitle,\n  .ComplaintCardFooter {\n    padding: 12px;\n  }\n\n  .ComplaintCardFooter {\n    flex-direction: column;\n    align-items: stretch;\n\n    .replyInputWrapper {\n      width: 100%;\n    }\n\n    button {\n      width: 100%;\n    }\n  }\n\n  .orderCards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 0 12px 12px;\n  }\n\n  .orderCard {\n    border: 1px solid #f0f0f0;\n    border-radius: 8px;\n    padding: 12px;\n    background: #fafafa;\n  }\n\n  .orderCardHead {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 8px;\n  }\n\n  .orderCardName {\n    font-weight: 600;\n    word-break: break-all;\n  }\n\n  .orderCardRow {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 13px;\n    line-height: 1.6;\n\n    span:first-child {\n      flex-shrink: 0;\n      color: #8c8c8c;\n    }\n\n    span:last-child {\n      text-align: right;\n      word-break: break-all;\n    }\n  }\n\n  .orderCard button {\n    margin-top: 12px;\n  }\n\n  :global {\n    .ant-input,\n    .ant-input-textarea textarea {\n      font-size: 16px;\n    }\n\n    .ant-steps-item-title {\n      font-size: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"complaintTitle": `tYZonBvDxggpt0q7`,
	"goBackText": `gNyNVaVlBuUDeBiN`,
	"goBackTextMargin": `YNZFvyp6QUQYLhkr`,
	"complaintMainTitle": `el9HIrE39uU4W03O`,
	"complaintTitleTags": `SBIdTRA9ZlAwmPLw`,
	"borderTopLine": `qyh6gsyMGd4AGh2u`,
	"compaintInfo": `aH6qrGlX95kR_LV4`,
	"compaintInfoTitle": `zbEW6STCUgC3V8rX`,
	"complainBtnGroup": `Gpb7vSKnN00OqxKq`,
	"btnFinsh": `xAzXw1zHyvoXXB_L`,
	"compaintInfoMoney": `Iy7SLiPjj4fpvn51`,
	"productName": `VruUblXBJxs5Z1ty`,
	"goBack": `tuXJhtor91g2gwW0`,
	"complaintDetailWidthWrapper": `jAsjt6yyc7UPyk2q`,
	"complaintDetailListStyle": `Ww8sIQZTnf88MMzr`,
	"ComplaintCardTitle": `bvPkOQrBq8o7OopG`,
	"ComplaintCardContent": `bamuHvFCCwSB3boP`,
	"ComplaintResponse": `LSITa7zJCo0Adlim`,
	"ComplaintResponseUser": `TIPXF_ajr7YxRFdq`,
	"ComplaintUserMarginRight": `oWlK16b7sKMUBXqX`,
	"ComplaintResponseSessionWapper": `wofRwBdgnl43v2UB`,
	"ComplaintResponseSession": `TxH68m3wSck4uCZQ`,
	"replyImages": `TnYe_am82AnjP4HI`,
	"replyImage": `RpRno8rKMOMQSK3a`,
	"ComplaintResponseSessionDate": `I1ciqLGRHQkwruLv`,
	"alipayTip": `OLvn0C2mn9sEDWYq`,
	"alipaywrap": `tG5R9ZmShko22kYl`,
	"alipayTipIcon": `R8f9LAmikIAEGq7x`,
	"alipayTipText": `NEB9t0_YYr0DBCH0`,
	"ComplaintCardFooter": `uNFvOf41iAP4P4ZB`,
	"replyInputWrapper": `VBy4TE1PiR0iXoZb`,
	"textAreaStyle": `xijpiwVWzpoAgzVj`,
	"isMobile": `Sx1xkdNmHBAsLRBM`,
	"infoValue": `h0u5lee73IRCk6EE`,
	"orderCards": `VQbGz2XIPIT4N_Bc`,
	"orderCard": `jrOWTQyF7eAHyxOY`,
	"orderCardHead": `dPQWBBrrl_43nCFB`,
	"orderCardName": `EYAIuhlOL446AToH`,
	"orderCardRow": `Q04aJVgODcE6zZy5`
};
export default ___CSS_LOADER_EXPORT___;
